<template>
  <div :class="['route-box', hasPadding && 'padding']">
    <div class="top-img">
      <img src="../../../assets/images/card_top_bg.png" />
    </div>
    <div class="top-text-img">
      <img src="../../../assets/images/title_gdhsdt.png" />
    </div>
    <slot></slot>
    <div class="bottom-msg" v-if="!noBottom">
      <div class="left-msg">
        <div class="userinfo">
          <img :src="userInfo.userAvatarImg" />
          <div class="user-name">{{ userInfo.userName }}</div>
        </div>
        <div class="share-msg">这条路线值得安利 </div>
        <div class="share-msg">快来跟我一起打卡吧！</div>
      </div>
      <div class="right-msg">
        <img :src="qrCodeUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CenterRoute',
  data() {
    return {}
  },
  props: {
    noBottom: {
      type: Boolean,
      default: false,
    },
    qrCodeUrl: {
      type: String,
      default: '',
    },
    hasPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo',
    }),
    routeListLength() {
      return this.routeList.length
    },
  },
}
</script>

<style lang="scss" scoped>
$scale: 1;
.route-box {
  height: (8.96rem / $scale);
  width: 100%;
  margin: 0 auto;
  background: #ffdab4;
  position: relative;
  .top-img {
    position: relative;
    height: (1.3rem / $scale);
    & > img {
      width: 100%;
      height: 100%;
    }
  }
  .top-text-img {
    position: absolute;
    top: (0.4rem / $scale);
    left: 50%;
    transform: translate(-50%, 0);
    width: (3.78rem / $scale);
    height: (0.71rem / $scale);
    & > img {
      display: block;
      width: (3.78rem / $scale);
      height: (0.71rem / $scale);
    }
  }

  .bottom-msg {
    position: absolute;
    bottom: (0.55rem / $scale);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 (0.4rem / $scale);
    .left-msg {
      .userinfo {
        display: flex;
        align-items: center;
        margin-bottom: (0.2rem / $scale);
        & > img {
          width: (0.5rem / $scale);
          height: (0.5rem / $scale);
          border-radius: 0.5rem;
        }
        .user-name {
          margin-left: (0.24rem / $scale);
          font-size: (0.28rem / $scale);
          color: #ab051b;
          font-weight: 600;
        }
      }
      .share-msg {
        font-size: (0.28rem / $scale);
        color: #b23f00;
        font-weight: 400;
      }
    }
    .right-msg {
      width: (1.6rem / $scale);
      height: (1.6rem / $scale);
      & > img {
        width: (1.6rem / $scale);
        height: (1.6rem / $scale);
      }
    }
  }
}
.route-box.padding {
  width: calc((100% - 0.7rem) / $scale);
  border-radius: 0.2rem;
}
.route-box.padding .top-img {
  & > img {
    border-radius: 0.2rem;
  }
}
</style>